// extracted by css-extract-rspack-plugin
export default {"price":"AxKX4_2IfJ4j1wgI"};